import * as a from 'actions/stores';

const initial = {
  data: [],
  error: null,
};

const stores = (state = initial, action = null) => {
  switch (action.type) {
    case a.INITIATE_STORES:
      return initial;
    case a.SET_STORES:
      return {
        ...state,
        data: action.stores,
        error: null,
      };
    case a.SET_STORES_ERROR:
      return {
        ...state,
        error: action.error,
        data: null,
      };
    default:
      return state;
  }
};

export default stores;
